<div class="quote-empty-state">
  <div class="empty-state-content">
    <!-- Empty state per tab "Nuovi" con ricezione abilitata -->
    <ng-container *ngIf="activeTab === 'new' && isQuotesEnabled">
      <div class="empty-state-icon">
        <i class="ti ti-clock icon"></i>
      </div>
      <h5 class="empty-state-title">
        {{ 'Quotes are coming!' | translate }}
      </h5>
      <p class="empty-state-description">
        {{ "Don't worry, we're working on it for you. Most quotes are sent within 24-48 hours." | translate }}
      </p>
      <div class="empty-state-actions">
        <p class="actions-title">{{ 'In the meantime, you can:' | translate }}</p>
        <ul class="actions-list">
          <li>{{ 'Review your request details above' | translate }}</li>
          <li>{{ 'Explore other treatment options' | translate }}</li>
          <li>{{ 'Check your notification settings' | translate }}</li>
        </ul>
      </div>
      <div class="action-item">
        <i class="ti ti-bell action-icon"></i>
        <span>{{ "You'll receive a notification as soon as the first quote arrives" | translate }}</span>
      </div>
    </ng-container>

    <!-- Messaggio ricezione disabilitata (solo tab "Nuovi") -->
    <ng-container *ngIf="activeTab === 'new' && !isQuotesEnabled">
      <div class="empty-state-icon">
        <i class="ti ti-bell-off icon"></i>
      </div>
      <h5 class="empty-state-title">
        {{ 'Quote reception disabled' | translate }}
      </h5>
      <p class="empty-state-description">
        {{ "You have disabled the reception of new quotes. You will not receive further offers from clinics for this
        request." | translate }}
        <br><br>
        <strong>{{ "Note: You will still receive quotes from clinics you expressed interest in." | translate }}</strong>
      </p>
      <div class="empty-state-actions">
        <p class="actions-title">{{ 'What can you do?' | translate }}</p>
        <ul class="actions-list">
          <li>{{ 'Review the quotes you have already received' | translate }}</li>
          <li>{{ 'Reactivate quote reception at any time using the toggle above' | translate }}</li>
          <li>{{ 'Create a new request if your needs have changed' | translate }}</li>
        </ul>
      </div>
      <div class="action-item">
        <i class="ti ti-info-circle action-icon"></i>
        <span>{{ "You can reactivate quote reception at any time" | translate }}</span>
      </div>
    </ng-container>

    <!-- Empty state per tab "Ricevuti" e "In Attesa" -->
    <ng-container *ngIf="activeTab === 'received' || activeTab === 'waiting'">
      <div class="empty-state-icon">
        <i class="ti ti-file-search icon"></i>
      </div>
      <h5 class="empty-state-title">
        {{ 'No quotes yet' | translate }}
      </h5>
      <p class="empty-state-description">
        <ng-container *ngIf="activeTab === 'received'">
          {{ "No clinics have accepted your quote requests yet. Once a clinic decides to show you their full quote, it
          will appear here." |
          translate }}
        </ng-container>
        <ng-container *ngIf="activeTab === 'waiting'">
          {{ "You don't have any quotes waiting for response. Once you show interest in a quote, it will appear here." |
          translate }}
        </ng-container>
      </p>
    </ng-container>
  </div>
</div>